/** STALE TIME FOR QUERIES */
const SECOND = 1e3;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;

export const STALE_SECONDS_FIFTEEN = SECOND * 15;
export const STALE_MINUTES_ONE = MINUTE;
export const STALE_MINUTES_FIVE = MINUTE * 5;
export const STALE_HOURS_ONE = HOUR;
export const STALE_INFINITY = Infinity;

export const NOTIFICATION_DURATION = {
	SHORT: SECOND * 5,
	LONG: SECOND * 10,
};

/** PATTERNS */
export const USERNAME_PATTERN = /^[a-zA-Z0-9_-]{4,255}$/;
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PASSWORD_PATTERN = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,255}$/;

/** ERROR MESSAGES */
export const EMAIL_REQUIRED_ERROR = "Please input your E-mail!";
export const EMAIL_FORMAT_ERROR = "The email must be a valid email address!";
export const PASSWORD_ERROR =
	"The password does not meet the requirements! Your password must be at least 8 characters, contain at least one uppercase (ex: A, B, etc.), at least one lowercase letter (ex: a, b, etc.), at least one number (ex: 0, 1, etc.) and at least one special character (ex: $, #, etc.).";
export const PASSWORD_CONFIRM_ERROR = "Please confirm your password!";
export const PASSWORD_MATCH_ERROR = "The password fields must match!";
export const TERMS_ACCEPTED_ERROR = "You should accept agreement";

/** DELAYS */
export const DELAY_IMMEDIATE = 0;
export const DELAY_TIME_100 = 100;
export const DELAY_TIME_250 = 250;
export const DELAY_TIME_300 = 300;
export const DELAY_TIME_500 = 500;
export const DELAY_TIME_800 = 800;
export const DELAY_TIME_1000 = 1000;
export const DELAY_TIME_2000 = 2000;
export const DELAY_TIME_3000 = 3000;
export const DELAY_TIME_4500 = 4500;
export const DELAY_TIME_5000 = 5000;
export const DELAY_TIME_7000 = 7000;
export const DELAY_TIME_10000 = 10000;

/** STYLES */
export const SKELETON_BLOCK_CLASS = "animate-pulse rounded-md bg-secondary";
